import { WebAuth } from 'auth0-js';

export default defineNuxtPlugin(() => {
  const testingStore = useTestingStore();
  const isAuth0Enabled = testingStore.hasEnabledFeature('web_auth0InStaticweb');

  if (isAuth0Enabled) {
    const appConfig = useRuntimeConfig();
    const sessionStore = useSessionStore();
    const { useUrl } = useUrls();

    const $auth0 = new WebAuth({
      domain: appConfig.public.AUTH0_DOMAIN,
      clientID: appConfig.public.AUTH0_CLIENTID,
      redirectUri: useUrl.getAuth0CallbackPageUrl(),
      responseType: 'code',
      audience: appConfig.public.AUTH0_AUDIENCE,
    });

    sessionStore.setAuth0($auth0);

    return { provide: { auth0: $auth0 } };
  }
});
